
<template>
  <v-container>
    <router-view></router-view>
    <trucks-list></trucks-list>
  </v-container>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
//import validations from '@/mixins/validations'
//import Api from '@/api/index';

export default {
  name: 'Trucks',
  //mixins: [ validations ],
  components: {
    TrucksList: () => import('@/_backoffice/_registrations/components/trucks/TrucksList.vue'),
  },
  data() {
    return {
      
    }
  },
  methods: {
    name() {
      
    },
    ...mapActions({
      // function: 'Module/action'
      //addNotification: 'Notification/add'
    })
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
}
</script>

<style scoped>

</style>